<template>
  <v-row id="email-management">
    <v-col md="12">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr class="header-row">
              <th class="header-text">Template ID</th>
              <th class="header-text tw-w-40" />
            </tr>
          </thead>
          <tbody>
            <tr v-for="e in mEmailTemplatesList" :key="e.id">
              <td>{{ e.id }}</td>
              <td>
                <edit-email-template
                  v-if="userCompany.isAdmin"
                  :key="`edit-${e.id}`"
                  :emailTemplate="e"
                ></edit-email-template>
                <delete-email-template
                  v-if="userCompany.isAdmin"
                  :key="`delete-${e.id}`"
                  :emailTemplateID="e.id"
                ></delete-email-template>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <add-email-template v-if="userCompany.isAdmin"></add-email-template>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import AddEmailTemplate from "./add-email-template";
import DeleteEmailTemplate from "./delete-email-template";
import EditEmailTemplate from "./edit-email-template";
import fc from "@/firebaseConfig";

export default {
  name: "EmailManagement",
  components: {
    AddEmailTemplate,
    DeleteEmailTemplate,
    EditEmailTemplate
  },
  data() {
    return {
      showEmailInput: false,
      mEmailTemplatesListUnsubscribeObject: null,
      mEmailTemplatesList: []
    };
  },
  methods: {
    // checkRole: function (user) {
    //   return getRole(user)
    // }
  },
  computed: mapState({
    users: state => state.user.list,
    userCompany: state => state.user.userCompany
  }),
  beforeDestroy() {
    this.$store.dispatch("user/getUserListUnsubscribe");
  },
  created() {
    let companyId = this.$route.params.companyId;
    if (companyId) {
      this.$store.dispatch("user/getList", { companyId: companyId });
      this.$store.dispatch("user/getRoleUser", { companyId: companyId });

      if (this.mEmailTemplatesListUnsubscribeObject) {
        this.mEmailTemplatesListUnsubscribeObject();
      }
      this.mEmailTemplatesListUnsubscribeObject = fc.db
        .collection(`Companies/${companyId}/EmailTemplates`)
        .onSnapshot(docs => {
          this.mEmailTemplatesList = [];
          docs.forEach(doc => {
            const data = doc.data();
            data.id = doc.id;
            this.mEmailTemplatesList.push(data);
          });
          // console.log(this.mEmailTemplatesList)
        });
    }
  }
};
</script>
<style lang="scss">
#user-management {
  .header-row {
    background-color: #f0f0f0 !important;
  }

  .v-data-table__wrapper {
    border-radius: 14px;
  }

  .header-text {
    font-size: 16px !important;
    font-weight: bold !important;
    text-align: center !important;
  }
}
</style>
